module.exports = __webpack_public_path__ + "static/media/noxx-solo.324b2cf6.pdf";